import _extends from "@babel/runtime/helpers/extends";
import React, { lazy, Suspense } from 'react';
import PageLoadingSpinner from '@jobmatchme/ui/es/components/PageLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
var ExportAppContainer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '404' */'./');
});
export default (function (props) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: /*#__PURE__*/_jsx(PageLoadingSpinner, {
      fullHeight: true
    }),
    children: /*#__PURE__*/_jsx(ExportAppContainer, _extends({}, props))
  });
});